// A lazily loaded route or panel whose file is gone: after a deploy the old
// hashed chunks are replaced, and an open tab asking for one fails. A reload
// fetches the new index.html and its new chunk names.

const MESSAGES = [
  // Vite / native dynamic import, by browser:
  /Failed to fetch dynamically imported module/i, // Chromium
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
  // Next.js webpack chunks (tabs opened before the UI split):
  /Loading chunk .* failed/i,
];

export function isChunkLoadError(err: unknown): boolean {
  if (!err || typeof err !== "object") return false;
  const e = err as { name?: unknown; message?: unknown };
  if (e.name === "ChunkLoadError") return true;
  return typeof e.message === "string" && MESSAGES.some((re) => re.test(e.message as string));
}
